import {
    PasswordManagerTypes,
    RECEIVE_PASSWORD_LIST,
    LOADING_PASSWORD_LIST,
    REQUEST_PASSWORD_LIST,
    SET_RECORD_EXT_ID,
    SET_PASSWORD_DETAILS,
    TOGGLE_FAVOURITE,
    IPasswordDetails,
} from "./types";
import { AppThunkAction } from "..";
import * as httpClient from "../../util/httpClient";

export const actionCreators = {
    requestRequestPasswordList: (): AppThunkAction<PasswordManagerTypes> => (dispatch) => {
        dispatch({ type: LOADING_PASSWORD_LIST, loadingPasswordList: true });

        httpClient
            .sendRequest("POST", `api/securepassword/getPasswordList`)
            .then((data) => {
                dispatch({ type: RECEIVE_PASSWORD_LIST, passwordList: data });
                dispatch({ type: LOADING_PASSWORD_LIST, loadingPasswordList: false });
            })
            .catch(function (error) {
                dispatch({ type: RECEIVE_PASSWORD_LIST, passwordList: [] });
                dispatch({ type: LOADING_PASSWORD_LIST, loadingPasswordList: false });
            });

        dispatch({ type: REQUEST_PASSWORD_LIST });
    },
    setPasswordExtId:
        (passwordExtId: string): AppThunkAction<PasswordManagerTypes> =>
        (dispatch) => {
            dispatch({ type: SET_RECORD_EXT_ID, selectedPasswordRecordExtId: passwordExtId });
        },
    setPassworDetails:
        (passwordDetails: IPasswordDetails): AppThunkAction<PasswordManagerTypes> =>
        (dispatch) => {
            dispatch({ type: SET_PASSWORD_DETAILS, selectedPasswordDetails: passwordDetails });
        },
    toggleFavourite:
        (selectedPasswordRecordExtId: string): AppThunkAction<PasswordManagerTypes> =>
        (dispatch) => {
            dispatch({ type: TOGGLE_FAVOURITE, selectedPasswordRecordExtId: selectedPasswordRecordExtId });
        },
};
